import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Navigation from "./Navigation";
import ChatInterface from "./ChatInterface";
import "./Layout.css";

const Layout = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    if (isHomePage) {
      document.body.classList.add("home-page-lock-scroll");
    } else {
      document.body.classList.remove("home-page-lock-scroll");
    }

    return () => {
      document.body.classList.remove("home-page-lock-scroll");
    };
  }, [isHomePage]);

  return (
    <div className="layout">
      <Header />
      <main className={`main-content ${isHomePage ? "main-content-home" : ""}`}>
        {children}
      </main>
      <ChatInterface />
      <Navigation />
    </div>
  );
};

export default Layout;
